import { PaymentStates } from '~/config/types';

export const paymentStateTagDict: Record<PaymentStates, { name: string; tagColor?: string }> = {
  Arranging: { name: 'toPay', tagColor: 'warning' },
  Authorized: { name: 'toPay', tagColor: 'warning' },
  Cancelled: { name: 'cancelled', tagColor: 'error' },
  Declined: { name: 'declined', tagColor: 'error' },
  Error: { name: 'error', tagColor: 'error' },
  Settled: { name: 'paid', tagColor: 'success' },
};